export const DOMAINS_CHECKOUT_URL = 'https://pub$CURRENT_PUB$.bravenet.com/domains/index.php?new=1'

export const HOSTING_CHECKOUT_URL = 'https://pub$CURRENT_PUB$.bravenet.com/hosting/plans.php'


// WEBPACK FOOTER //
// ./lib/brave-api/constants.js